module.exports = __webpack_public_path__ + "static/media/smsPhone.e9309d46.svg";